export default __webpack_public_path__ + "static/media/AlertSystemMetric.6358010d.md";